import type { FaireProductEntity } from "../../entity_types/product";

export const p_qc82bxznpc: FaireProductEntity = {
  token: "p_qc82bxznpc",
  type: "product",
  name: "Double Heart Shell Pearl Gold Dangly Earrings Bridal ERG375",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/8cb63a4ac87b45ad6cf966e52bc5ee55eb59cc3bd720c6fe8f7c6163c3f59fa4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7773d3226489ed25d009a3ce4db8ac6efb96b65643c31909d4e09c673334ffe4.jpeg",
    "https://cdn.faire.com/fastly/64a042c0d85bd93d2250051ac696b40fe81dd6852e8baabd698559576fd655e0.jpeg",
  ],
  priceDollars: 27.56,
  description:
    "Double Heart Earrings Shell Pearl, Gold Hearts Dangly Earrings, Gold Detail, Gift For Her, Bridal jewelry, ERG375\nListing is for one set.\n\n18K Gold plating Over Brass\nEarring Measurements: top heart 12.5mm x 15mm bottom heart: 12.5mm x 17mm\nSizes Are Approximate\nlead, cadmium and nickel free\nBulk discount is available at drop down menu\nShip From Los Angeles\nOrders that exceeds $35 will enjoy a Free Shipping Service within the US",
  tags: [],
  msrpDollars: 55.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:58.405Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
